import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';

import { CODE_API } from 'constants/api';
import axios from 'utilities/axios';

const getCodeValue = (code, paymentIntentType) => {
  return useQuery(
    [CODE_API.getCodeValue.name(code)],
    () =>
      axios
        .get(CODE_API.getCodeValue.path(code), {
          params: {
            paymentIntentType,
          },
        })
        .then((res) => res.data),
    { enabled: !!code, onError: () => {} }
  );
};

const useGetCodeValue = (initialParams) => {
  const [params, setParams] = useState(initialParams);

  const data = getCodeValue(params?.code || '', params?.paymentIntentType);

  const handleChangeParams = useCallback((params) => {
    setParams((prevState) => ({ ...prevState, ...params }));
  }, []);

  return {
    ...data,
    handleChangeParams,
  };
};

export default useGetCodeValue;
